var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMenuClose = function SvgMenuClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M15.338 34.783c-.488.489-1.359.41-1.945-.176-.585-.586-.665-1.457-.176-1.945l19.445-19.445c.488-.489 1.359-.41 1.945.176.585.586.665 1.457.176 1.945L15.338 34.783zm-2.121-19.445c-.489-.488-.41-1.359.176-1.945.586-.585 1.457-.665 1.945-.176l19.445 19.445c.489.488.41 1.359-.176 1.945-.586.585-1.457.665-1.945.176L13.217 15.338z"
  })));
};
export default SvgMenuClose;